import WorkshopBatches from './WorkshopBatches';

export default WorkshopBatches;
